<template>
  <aside class="error-wrapper" role="alert">
    <mark class="error-item">
      <font-awesome-icon icon="exclamation-triangle" class="error-item_icon" />
      <div class="error-item__description">
        <p class="error-item__description" v-if="foundErrorTranslation" v-html="$t('errors.' + error)"/>
        <p class="error-item__description" v-else-if="$te('errors.' + fallbackError)" v-html="$t('errors.' + fallbackError)"/>
        <p class="error-item__description" v-else v-html="$t('errors.generic_error')"/>

        <!-- Show extra error info when not in production -->
        <div class="error-item__description error-item__description--debugging" v-if="!foundErrorTranslation && !inProduction && showDebuggingErrorInfo">
          <p>This is only visible when not in production AND when we can't find a translation.</p> 
          <p>We couldn't find a translation for: {{ $t('errors.' + error) }}</p>
          <button @click="closeDebuggingError">Show only what user sees</button>
        </div>
      </div>
    </mark>
  </aside>
</template>

<script>
import { mapState, mapGetters } from "vuex"

export default {
  name: "global-error",
  data() {
    return {
      showDebuggingErrorInfo: true
    }
  },
  methods: {
    closeDebuggingError() {
      this.showDebuggingErrorInfo = false;
    }
  },
  computed: {
    foundErrorTranslation() {
      return this.$te('errors.' + this.error);
    },
    ...mapState(['error', 'fallbackError']),
    ...mapGetters(['inProduction'])
  },
  watch: {
    error() {
      this.showDebuggingErrorInfo = true
    }
  }
};
</script>